import React, { useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { isNativeApp } from "@/lib/utils";

export default function PullToRefresh({ onRefresh, children }) {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(null);

  if (!isNativeApp()) return children;

  const onTouchStart = (e) => {
    startY.current = window.scrollY <= 0 ? e.touches[0].clientY : null;
  };
  const onTouchMove = (e) => {
    if (startY.current === null || refreshing) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0 && window.scrollY <= 0) setPull(Math.min(dy * 0.45, 90));
  };
  const onTouchEnd = async () => {
    if (refreshing) return;
    if (pull > 60) {
      setRefreshing(true);
      setPull(54);
      try { await onRefresh?.(); } catch {}
      setRefreshing(false);
    }
    setPull(0);
    startY.current = null;
  };

  return (
    <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} data-testid="pull-to-refresh">
      <div
        style={{ height: pull, transition: refreshing || pull === 0 ? "height 220ms ease" : "none" }}
        className="flex items-end justify-center overflow-hidden"
        data-testid="ptr-indicator"
      >
        <RefreshCw
          size={20}
          strokeWidth={2.5}
          className={`mb-3 ${refreshing ? "animate-spin" : ""}`}
          style={refreshing ? undefined : { transform: `rotate(${pull * 3}deg)`, opacity: Math.min(pull / 60, 1) }}
        />
      </div>
      {children}
    </div>
  );
}
